import { forwardRef, Ref, RefObject } from 'react';
import styles from './ViewerCanvas.module.css';

interface ViewerCanvasProps {
  cornerstoneRef: RefObject<HTMLDivElement | null>;
  isRendered: boolean;
}

export const ViewerCanvas = forwardRef<HTMLDivElement, ViewerCanvasProps>(
  ({ cornerstoneRef, isRendered }, ref) => (
    <div className={styles.wrapper}>
      <div
        key="Viewer content element"
        className={styles.container}
        ref={cornerstoneRef || (ref as Ref<HTMLDivElement>)}
        data-rendered={isRendered}
      />
    </div>
  )
);

ViewerCanvas.displayName = 'ViewerCanvas';
